import { Input, Row, Col, Avatar, Badge, Popover, Divider, Space } from 'antd'
import { LeftOutlined } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { logout } from '../actions';
import SideMenuButton from './sidemenubutton'

function CDXTitleBar({ title, icon = null, onBackClicked = () => { }, renderTitle = null, children, quiet = false }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const content = renderTitle ? renderTitle : (

        <Space size="small">
            {icon && !isMobile && !quiet && (() => { const Icon = icon; return (
                <div style={{ width: "32px", height: "32px", borderRadius: "8px", background: "#eef2ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <Icon size={16} color="#6366f1" />
                </div>
            ); })()}
            <span style={{ fontSize: quiet ? (isMobile ? "13px" : "14px") : (isMobile ? "14px" : "17px"), fontWeight: quiet ? 500 : 600, color: quiet ? "#94a3b8" : "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: isMobile ? "calc(100vw - 80px)" : "none" }} >
                {title}
            </span>
        </Space>
    )
    return (
        <Row justify="left" align="middle" type="flex" style={{ height: "56px", width: "100%", backgroundColor: "#ffffff", borderBottom: "1px solid #f1f5f9", zIndex: "5", paddingLeft: "8px", overflow: "hidden" }}>
            <Col style={{ width: "44px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <div onClick={onBackClicked} style={{ width: "32px", height: "32px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#64748b", fontSize: "16px", transition: "background 0.15s, color 0.15s" }}
                    onMouseEnter={e => { e.currentTarget.style.background = "#f1f5f9"; e.currentTarget.style.color = "#6366f1"; }}
                    onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#64748b"; }}>
                    <LeftOutlined />
                </div>
            </Col>
            <Col style={{ minWidth: 0, flex: 1, display: 'flex', alignItems: 'center' }}>
                {children ? children : content}
            </Col>
        </Row>
    )
}


const mapStateToProps = (state) => {
    return { userdata: state.userdata };
}

export default connect(mapStateToProps, { logout })(CDXTitleBar);
